/*  MUI  */
import { Alert, Box, Typography } from '@mui/material';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';
import { SubscriptionChannel } from 'application/Shared/types/subscriptionChannel';
import { Tenant, TenantSettings } from 'application/Shared/types/tenant';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';
import { useTenantInfoByTenantId } from 'hooks/redux/Selectors/tenants';

/*  React  */
import React from 'react';
import { Trans } from 'react-i18next';
import { useParams } from 'react-router';

// View Pricing version
// export const TrialBanner = ({ session }) => {
//     const { t } = useTranslation();
//     const daysLeft = getDaysLeftOnTrial(session);

//     return (
//         <Alert
//             className="no-print"
//             icon={false}
//             severity="warning"
//             style={{
//                 justifyContent: 'center',
//                 left: 0,
//                 paddingBottom: 0,
//                 paddingTop: 0,
//                 position: 'absolute',
//                 top: 0,
//                 width: '100%',
//                 zIndex: '1000'
//             }}
//         >
//             <Box display="flex" fontSize="13px">
//                 <Box
//                     alignSelf="center"
//                     data-testid="bannerTimeRemainingMessage"
//                 >
//                     <Typography
//                         dangerouslySetInnerHTML={{
//                             __html: t('Trial.daysRemaining', {
//                                 daysLeft
//                             })
//                         }}
//                         sx='text.warning'
//                     />
//                 </Box>
//                 <Link
//                     to="/home/viewPricing"
//                     data-trackid="trialBannerViewPricingLink"
//                 >
//                     <Button
//                         color="primary"
//                         variant="contained"
//                         size="small"
//                         style={{ marginLeft: '8px', minWidth: '128px' }}
//                         data-trackid="trialBannerViewPricingButton"
//                     >
//                         {t('Trial.viewPricing')}
//                     </Button>
//                 </Link>
//             </Box>
//         </Alert>
//     );
// };

/**
 * Custom hook to retrieve tenant settings
 * @param partnerTenant - The partner tenant object or undefined
 * @returns TenantSettings object for either the partner tenant or current session tenant
 */
export const useGetSettings = (
    partnerTenant: Tenant | undefined
): TenantSettings => {
    const session = useSession();

    if (partnerTenant && partnerTenant.id !== session.tenant?.id) {
        return partnerTenant?.settings || {};
    }

    return session?.tenant?.settings || {};
};

export const TrialBanner = (): React.ReactNode => {
    const { partnerId } = useParams();
    const partnerTenantInfo = useTenantInfoByTenantId(partnerId!);
    const partnerTenant = partnerTenantInfo?.tenant;
    const partnerTenantSettings = useGetSettings(partnerTenant);
    const trialDaysLeft = Helpers.trialDaysLeft(partnerTenantSettings);
    const subscriptionChannel = partnerTenant?.subscriptionChannel;

    return (
        <Alert
            className="no-print"
            icon={false}
            severity="warning"
            style={{
                justifyContent: 'center',
                left: 0,
                paddingBottom: 0,
                paddingTop: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                zIndex: '1000'
            }}
        >
            <Box
                alignSelf="center"
                sx={{ paddingY: '4px' }}
                data-testid="bannerDaysRemainingContactForPricing"
            >
                <Trans
                    i18nKey="Trial.daysRemainingContactForPricing"
                    count={trialDaysLeft}
                    components={{
                        Date: (
                            <Typography variant="span" fontWeight={600}>
                                {trialDaysLeft.toString()}
                            </Typography>
                        ),
                        EmailAddress: (
                            <Typography variant="span" fontWeight={600}>
                                {subscriptionChannel ===
                                SubscriptionChannel.PAX8
                                    ? 'channel@auvik.com'
                                    : 'sales@auvik.com'}
                            </Typography>
                        )
                    }}
                />
            </Box>
        </Alert>
    );
};
